import { useState, useEffect } from "react";

// Returns `value` only after it has stopped changing for `delay` ms.
// The initial render returns the initial value immediately, so list pages still
// fetch right away on mount (no added first-load delay) and only SUBSEQUENT
// changes (typing in the search box) are debounced. Behaviour and results are
// identical — this purely collapses per-keystroke API calls into one.
export default function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
